import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5f7c2132"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "strategy-inner"
};
const _hoisted_2 = {
  key: 0,
  class: "strategy-info"
};
const _hoisted_3 = {
  class: "strategy-info-value active"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass($props.rowClassName($props.week.week, $props.rowName)),
    onMouseenter: _cache[0] || (_cache[0] = $event => $props.onEnter($props.week.week, $props.rowName, $props.week.week_status))
  }, [!!$props.shadow?.strategy ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(['strategy-box', $props.shadow.strategy_status])
  }, [_createElementVNode("div", _hoisted_1, [$props.shadow.strategy_status == 'start' || $props.shadow.strategy_status == 'single' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
    class: _normalizeClass(['strategy-info-badge', $props.shadow.strategy.type])
  }, [_createVNode(_component_app_icon, {
    icon: `strategy-${$props.shadow.strategy.type}`,
    size: 12
  }, null, 8, ["icon"])], 2), _createElementVNode("div", _hoisted_3, [$props.shadow.strategy.type === 'fixed' ? (_openBlock(), _createBlock(_component_currency_value, {
    key: 0,
    value: $props.shadow.strategy.value,
    currency: $props.currency,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency"])) : (_openBlock(), _createBlock(_component_percentage_value, {
    key: 1,
    value: $props.shadow.strategy.value
  }, null, 8, ["value"]))])])) : _createCommentVNode("", true)])], 2)) : _createCommentVNode("", true)], 34);
}